"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Controls;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactIntl = require("react-intl");

var _ControlsModule = _interopRequireDefault(require("./Controls.module.scss"));

var _inputElements = require("../../../../../../inputElements");

var _EChatChannel = _interopRequireDefault(require("../../EChatChannel"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/* eslint-disable @typescript-eslint/no-unused-vars */

/* Tooltips
Normal on / Normal off
Shout on / Shout off
Party on / Party off
Guild on / Guild off
Whisper on / Whisper off
System on / System off
Damage on / Damage off
*/
function getButtonTypeForChatChannel(channel) {
  switch (channel) {
    case _EChatChannel.default.GENERAL:
      return _inputElements.EButtonType.CHAT_GENERAL;

    case _EChatChannel.default.SHOUT:
      return _inputElements.EButtonType.CHAT_SHOUT;

    case _EChatChannel.default.PARTY:
      return _inputElements.EButtonType.CHAT_PARTY;

    case _EChatChannel.default.GUILD:
      return _inputElements.EButtonType.CHAT_GUILD;

    case _EChatChannel.default.WHISPER:
      return _inputElements.EButtonType.CHAT_WHISPER;

    case _EChatChannel.default.SYSTEM:
      return _inputElements.EButtonType.CHAT_SYSTEM;

    case _EChatChannel.default.DAMAGE:
      return _inputElements.EButtonType.CHAT_DAMAGE;

    default:
      throw new Error("Unknown chat type '".concat(JSON.stringify(channel), "' to determine button."));
  }
}

function Controls(_ref) {
  var enabledChannels = _ref.enabledChannels,
      focusedChannel = _ref.focusedChannel,
      _onClick = _ref.onClick,
      _onDoubleClick = _ref.onDoubleClick,
      className = _ref.className,
      style = _ref.style;

  var _useIntl = (0, _reactIntl.useIntl)(),
      formatMessage = _useIntl.formatMessage;

  var renderButtonForChatChannel = (0, _react.useCallback)(function (channel) {
    var isFocused = focusedChannel === channel;
    var isEnabled = enabledChannels.includes(channel);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(_ControlsModule.default.entry, _ControlsModule.default[channel], isFocused && _ControlsModule.default.isFocused, !isEnabled && _ControlsModule.default.isDisabled)
    }, isFocused && /*#__PURE__*/_react.default.createElement("div", {
      className: _ControlsModule.default.isFocusedOverlay
    }), /*#__PURE__*/_react.default.createElement(_inputElements.Button, {
      type: getButtonTypeForChatChannel(channel),
      onClick: function onClick() {
        return _onClick(channel);
      } // TODO: onRightClick={(): void => onRightClick(chatType)}
      ,
      onDoubleClick: function onDoubleClick() {
        return _onDoubleClick(channel);
      }
    }));
  }, [focusedChannel, enabledChannels, _onClick, _onDoubleClick]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_ControlsModule.default.controls, className),
    style: style
  }, renderButtonForChatChannel(_EChatChannel.default.GENERAL), renderButtonForChatChannel(_EChatChannel.default.SHOUT), renderButtonForChatChannel(_EChatChannel.default.PARTY), renderButtonForChatChannel(_EChatChannel.default.GUILD), renderButtonForChatChannel(_EChatChannel.default.WHISPER), renderButtonForChatChannel(_EChatChannel.default.SYSTEM), renderButtonForChatChannel(_EChatChannel.default.DAMAGE));
}